/** @file Kbd: a key-cap label for a shortcut (already formatted by the shortcuts chordLabel). */
import type { ReactElement } from 'react';

/** Renders `children` (e.g. `Ctrl+Z`) as a key cap. */
export function Kbd({ children }: { children: string }): ReactElement {
  return <kbd className="p3-kbd">{children}</kbd>;
}
